import React, { Component } from 'react';


class RcTransferThankyou extends Component {

    submitScreenFour = () => {
        alert('back to Home Page');
        //window.location.reload();
    };
    render() {
        return (
            <React.Fragment>
                <div className="wrapper">
                    <div className="mContainer">
                        <div className="mMiddle">
                            <div className="thankYouBox">
                                <img src="/assets/images/thanks.svg" alt="" />
                                <div className="aa">Thank You</div>
                                <div className="bb">Expert will reach you soon.</div>
                            </div>
                            <div className="submitRow">
                                <button
                                    className="yellowBtn"
                                    type="button"
                                    onClick={this.submitScreenFour}
                                >
                                    Back to Home
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default RcTransferThankyou;
